import {
  PLUGIN_TRIGGER,
  VISIBLE_CHANGE_POPUP_CONTENT,
  CLEAR_PLUGIN_CONTENT,
  SET_SOURCE_PLUGINS,
  PLUGIN_PRIVATE_FILTERS,
  PLUGIN_FILTERS,
  PLUGIN_INTERACTION_FILTERS,
  UPDATED_PLUGINS,
  ALL_PLUGINS_ALL_FILTERS,
  PLUGIN_PRIVATE_FILTERS_TITLE,
  CLEAR_REDUCER,
  MOVE_INTERACTION_FILTERS,
  CLONE_INTERACTION_FILTERS,
  ADD_PLUGIN,
  ADD_PLUGINS_BATCH,
  REMOVE_PLUGIN
} from "./PluginTriggerAction";

/**
 *
 * @param {*} state
 * @param {*} action
 *
 * gelen action a göre ilgili datayı store un state ine yazar
 */
export default function PluginTriggerReducer(
  state = {
    plugins: new Map(),
    pluginContent: {},
    pluginInteractionFilters: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> filters
    pluginPrivateInteractionFilters: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> privateFilters
    pluginPrivateInteractionFiltersTitle: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> titleFilters
    positions: {},
    isActionListVisible: false,
    visiblePopupContent: false,
    isAction: false,
    sourcePluginsWithValues: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> values
    allPluginsAllFilters: new Map() // Outer Map: dashboardId -> Inner Map: pluginId -> filters
  },
  action
) {
  switch (action.type) {
    case PLUGIN_TRIGGER:
      return {
        ...state,
        pluginContent: action.payload.pluginContent,
        positions: action.payload.positions,
        isActionListVisible: action.payload.isActionListVisible,
        isAction: action.payload.isAction,
        visiblePopupContent: action.payload.isAction === true,
      };
    case PLUGIN_FILTERS:
      return {
        ...state,
        pluginInteractionFilters: action.payload,
      };
    case PLUGIN_INTERACTION_FILTERS:
      return {
        ...state,
        pluginInteractionFilters: action.payload,
      };
    case PLUGIN_PRIVATE_FILTERS:
      return {
        ...state,
        pluginPrivateInteractionFilters: action.payload,
      };
    case PLUGIN_PRIVATE_FILTERS_TITLE:
      return {
        ...state,
        pluginPrivateInteractionFiltersTitle: action.payload,
      };
    case VISIBLE_CHANGE_POPUP_CONTENT:
      return {
        ...state,
        visiblePopupContent: action.payload,
      };
    case CLEAR_PLUGIN_CONTENT:
      return {
        ...state,
        pluginContent: action.payload,
      };
    case SET_SOURCE_PLUGINS:
      return {
        ...state,
        sourcePluginsWithValues: action.payload
      }
    case UPDATED_PLUGINS:
      return {
        ...state,
        plugins: action.payload
      }
    case ADD_PLUGIN:
      const addedPluginsMap = new Map(state.plugins);
      addedPluginsMap.set(action.payload.id, action.payload);
      return {
        ...state,
        plugins: addedPluginsMap
      };
    case ADD_PLUGINS_BATCH:
      const batchAddedPluginsMap = new Map(state.plugins);
      action.payload.forEach(plugin => {
        batchAddedPluginsMap.set(plugin.id, plugin);
      });
      return {
        ...state,
        plugins: batchAddedPluginsMap
      };
    case REMOVE_PLUGIN:
      const removedPluginsMap = new Map(state.plugins);
      removedPluginsMap.delete(action.payload);
      return {
        ...state,
        plugins: removedPluginsMap
      };
    case ALL_PLUGINS_ALL_FILTERS:
      return {
        ...state,
        allPluginsAllFilters: action.payload
      }
    case CLEAR_REDUCER:
     return {
        plugins: new Map(),
        pluginContent: {},
        pluginInteractionFilters: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> filters
        pluginPrivateInteractionFilters: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> privateFilters
        pluginPrivateInteractionFiltersTitle: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> titleFilters
        positions: {},
        isActionListVisible: false,
        visiblePopupContent: false,
        isAction: false,
        sourcePluginsWithValues: new Map(), // Outer Map: dashboardId -> Inner Map: pluginId -> values
        allPluginsAllFilters: new Map() // Outer Map: dashboardId -> Inner Map: pluginId -> filters
      }
    case MOVE_INTERACTION_FILTERS:
      const fromDashboardId = action.payload.from;
      const toDashboardId = action.payload.to;

      if (fromDashboardId === toDashboardId) {
        return state;
      }

      const movedPluginInteractionFilters = new Map(state.pluginInteractionFilters);
      const movedPluginPrivateInteractionFilters = new Map(state.pluginPrivateInteractionFilters);
      const movedPluginPrivateInteractionFiltersTitle = new Map(state.pluginPrivateInteractionFiltersTitle);
      const movedSourcePluginsWithValues = new Map(state.sourcePluginsWithValues);
      const movedAllPluginsAllFilters = new Map(state.allPluginsAllFilters);

      movedPluginInteractionFilters.set(toDashboardId, movedPluginInteractionFilters.get(fromDashboardId));
      movedPluginPrivateInteractionFilters.set(toDashboardId, movedPluginPrivateInteractionFilters.get(fromDashboardId));
      movedPluginPrivateInteractionFiltersTitle.set(toDashboardId, movedPluginPrivateInteractionFiltersTitle.get(fromDashboardId));
      movedSourcePluginsWithValues.set(toDashboardId, movedSourcePluginsWithValues.get(fromDashboardId));
      movedAllPluginsAllFilters.set(toDashboardId, movedAllPluginsAllFilters.get(fromDashboardId));

      movedPluginInteractionFilters.delete(fromDashboardId);
      movedPluginPrivateInteractionFilters.delete(fromDashboardId);
      movedPluginPrivateInteractionFiltersTitle.delete(fromDashboardId);
      movedSourcePluginsWithValues.delete(fromDashboardId);
      movedAllPluginsAllFilters.delete(fromDashboardId);

      return {
        ...state,
        pluginInteractionFilters: movedPluginInteractionFilters,
        pluginPrivateInteractionFilters: movedPluginPrivateInteractionFilters,
        pluginPrivateInteractionFiltersTitle: movedPluginPrivateInteractionFiltersTitle,
        sourcePluginsWithValues: movedSourcePluginsWithValues,
        allPluginsAllFilters: movedAllPluginsAllFilters
      }
    case CLONE_INTERACTION_FILTERS:
      const sourceDashboardId = action.payload.source;
      const targetDashboardId = action.payload.target;

      if (sourceDashboardId === targetDashboardId) {
        return state;
      }

      const clonedPluginInteractionFilters = new Map(state.pluginInteractionFilters);
      const clonedPluginPrivateInteractionFilters = new Map(state.pluginPrivateInteractionFilters);
      const clonedPluginPrivateInteractionFiltersTitle = new Map(state.pluginPrivateInteractionFiltersTitle);
      const clonedSourcePluginsWithValues = new Map(state.sourcePluginsWithValues);
      const clonedAllPluginsAllFilters = new Map(state.allPluginsAllFilters);

      clonedPluginInteractionFilters.set(targetDashboardId, clonedPluginInteractionFilters.get(sourceDashboardId));
      clonedPluginPrivateInteractionFilters.set(targetDashboardId, clonedPluginPrivateInteractionFilters.get(sourceDashboardId));
      clonedPluginPrivateInteractionFiltersTitle.set(targetDashboardId, clonedPluginPrivateInteractionFiltersTitle.get(sourceDashboardId));
      clonedSourcePluginsWithValues.set(targetDashboardId, clonedSourcePluginsWithValues.get(sourceDashboardId));
      clonedAllPluginsAllFilters.set(targetDashboardId, clonedAllPluginsAllFilters.get(sourceDashboardId));

      return {
        ...state,
        pluginInteractionFilters: clonedPluginInteractionFilters,
        pluginPrivateInteractionFilters: clonedPluginPrivateInteractionFilters,
        pluginPrivateInteractionFiltersTitle: clonedPluginPrivateInteractionFiltersTitle,
        sourcePluginsWithValues: clonedSourcePluginsWithValues,
        allPluginsAllFilters: clonedAllPluginsAllFilters
      }
    default:
      return state;
  }
}
